var aimagduureg = [
  { text: "Архангай", value: 1 },
  { text: "Баян-Өлгий", value: 2 },
  { text: "Баянхонгор", value: 3 },
  { text: "Булган", value: 4 },
  { text: "Говь-Алтай", value: 5 },
  { text: "Говьсүмбэр", value: 6 },
  { text: "Дорноговь", value: 7 },
  { text: "Дорнод", value: 8 },
  { text: "Дундговь", value: 9 },
  { text: "Завхан", value: 10 },
  { text: "Орхон", value: 11 },
  { text: "Өвөрхангай", value: 12 },
  { text: "Өмнөговь", value: 13 },
  { text: "Сүхбаатар", value: 14 },
  { text: "Сэлэнгэ", value: 15 },
  { text: "Төв", value: 16 },
  { text: "Увс", value: 17 },
  { text: "Ховд", value: 18 },
  { text: "Хөвсгөл", value: 19 },
  { text: "Хэнтий", value: 20 },
  { text: "Дархан-Уул", value: 21 },
  { text: "Баянзүрх (дүүрэг)", value: 22 },
  { text: "Сүхбаатар (дүүрэг)", value: 23 },
  { text: "Чингэлтэй (дүүрэг)", value: 24 },
  { text: "Баянгол (дүүрэг)", value: 25 },
  { text: "Сонгинохайрхан (дүүрэг)", value: 26 },
  { text: "Хан-Уул (дүүрэг)", value: 27 },
  { text: "Налайх (дүүрэг)", value: 28 },
  { text: "Багануур (дүүрэг)", value: 29 },
  { text: "Багахангай (дүүрэг)", value: 30 },
];

var teacherGeneraleInfo = {
  name: "Ерөнxий мэдээлэл",
  typeId: "section",
  fields: [
    {
      label: "Овог",
      typeInput: "text",
      typeId: "LAST_NAME",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Нэр",
      typeInput: "text",
      typeId: "FIRST_NAME",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Регистр",
      typeInput: "text",
      source: null,
    },
    {
      label: "Сургуулийн байрлаx Аймаг/Дүүрэг",
      typeInput: "select",
      options: JSON.parse(JSON.stringify(aimagduureg)),
      source: null,
    },
    {
      label: "Ажиллаж буй сургууль, ID",
      typeInput: "text",
      typeId: "legalEntityId",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Байгууллагын нэр",
      typeInput: "text",
      typeId: "organizationName",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Өмчийн xэлбэр",
      typeInput: "select",
      options: [
        {
          text: "Төрийн өмчит",
          value: 1,
        },
        { text: "Xувийн өмчит", value: 2 },
      ],
      source: null,
    },
    {
      label: "Албан тушаал",
      typeInput: "text",
      typeId: "jobId",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Эзэмшсэн боловсрол",
      typeInput: "text",
      source: null,
    },
    {
      label: "Ажилласан жил (Мэргэжлээрээ)",
      typeInput: "number",
      source: null,
      min: 3,
    },
    {
      label: "Ажилласан жил /нийгмийн даатгалын лавлагаа/",
      typeInput: "file",
      source: null,
    },
    {
      label: "Туxайн албан тушаалд томилогдсон тушаал",
      typeInput: "file",
      source: null,
    },
  ],
};
var generalRequirement3 = {
  name: "Ерөнxий шалгуур",
  typeId: "section",
  fields: [
    {
      label:
        "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
      typeInput: "file",
      source: null,
      indexx: 7,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
      typeInput: "file",
      source: null,
      indexx: 8,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
      typeInput: "number",
      source: null,
      min: 75,
    },
  ],
};
var generalRequirement5 = {
  name: "Ерөнxий шалгуур",
  typeId: "section",
  fields: [
    {
      label:
        "Багш мэргэжилтэй ерөнхий боловсролын сургуульд 3-аас доошгүй жил ажилласан байх",
      typeInput: "file",
      source: null,
      indexx: 5,
    },
    {
      label: "Тухайн албан тушаалын үндсэн орон тоонд ажилладаг байх",
      typeInput: "file",
      source: null,
      indexx: 6,
    },
    {
      label:
        "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
      typeInput: "file",
      source: null,
      indexx: 7,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
      typeInput: "file",
      source: null,
      indexx: 8,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
      typeInput: "number",
      source: null,
      min: 75,
    },
  ],
};

var conclusionInfoTeacher = {
  name: "Дүгнэлт",
  typeId: "section",
  isForAdmin: true,
  fields: [
    {
      label: "Мэргэжлийн зэргийн гэрчилгээний дугаар",
      typeInput: "text",

      source: null,
    },
    {
      label:
        "Мэргэжлийн зэрэг олгосон ажлын хэсгийн дүгнэлтийг хавсаргах",
      typeInput: "file",
      source: null,
    },
    {
      label: "Зааx аргач олгосон xурлын шийдвэрийн xувь",
      typeInput: "number",
      source: null,
    },
    {
      label: "Шийдвэрлэсэн огноо",
      typeInput: "date",
      source: null,
    },
  ],
};

export const teacherJsonTerguulehNew = {
  name: "[Багш] Тэргүүлэx мэргэшлийн зэрэг (Шинэ)",
  zeregType: 300,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),
    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [{ text: "Тэргүүлэx", value: 2 }],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [{ text: "Шинэ", value: 1 }],
        },
        {
          label: "Xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    //terguuleh shine
    {
      name: "Ерөнxий шалгуур",
      typeId: "section",
      fields: [
        {
          label:
            "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
          typeInput: "file",
          source: null,
          indexx: 7,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
          typeInput: "file",
          source: null,
          indexx: 8,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
          typeInput: "number",
          source: null,
          min: 75,
        },
      ],
    },
    {
      name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
      typeId: "section",
      indexx: "3.2.1",
      fields: [
        {
          label:
            "Сургалтын хөтөлбөрийн дагуу хичээлийг төлөвлөн үр дүнтэй зохион байгуулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Хичээл, сургалт зохион байгуулахдаа суралцагчийн ялгаатай суралцахуйг харгалзаж, дэмжлэг үзүүлдэг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Явцын үнэлгээг тогмол хэрэгжүүлдэг,үр дүнд үндэслэн арга зүйгээ сайжруулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Боловсролын цахим, нээлттэй нөөц хэрэглэгдэхүүн, үнэлгээг бүтээлчээр хэрэглэдэг, орон нутгийн түвшинд арга зүй, туршлагаа хуваалцдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
        {
          label:
            "Сургалтын нөөц хэрэглэгдэхүүнийг суралцагчдын ялгаатай хэрэгцээнд тохируулан хийж, хичээл сургалтын үйл ажиллагаанд үр дүнтэй ашигладаг байх",
          typeInput: "file",
          source: null,
          indexx: 5,
        },
        {
          label:
            "Шинэлэг бүтээлч арга зүй технологийг турших,  хэрэгжүүлэх зорилгоор хичээлийн судалгааг зохион байгуулж, үр дүнг сургууль, орон нутгийн түвшинд хэлэлцүүлсэн байх",
          typeInput: "file",
          source: null,
          indexx: 6,
        },
      ],
    },
    // {
    //   name: "Мэргэжил арга зүйн дэмжлэг",
    //   typeId: "section",
    //   indexx: "3.2.2",
    //   fields: [],
    // },
    {
      name: "Багшийн ёс зүй, манлайлал, хандлага",
      typeId: "section",
      indexx: "3.2.3",
      fields: [
        {
          label:
            "Сургуулийн алсын хараа, эрхэм зорилго, эрхэм зорилго, зорилтыг хэрэгжүүлэхэд хувь нэмэр оруулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Хүүхдийн авьяас, чадвар, хөгжих хэрэгцээг судалж, илрүүлэн, хөгжүүлэх үйл ажиллагааг санаачлан зохион байгуулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын чанар, үр дүнг сайжруулахад бусад багш нартай хамтран ажиллаж, арга зүй, туршлагаа сургууль бүсийн түвшинд хуваацдаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Багшийн хөгжил, сургалтын чанар үр дүнг сайжруулах чиглэлээр сургуулийн багш нар, мэргэжлийн багш нарын бүлэг, багийг чиглүүлэн зөвлөж, хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    {
      name: " Хамтын ажиллагаа",
      typeId: "section",
      indexx: "3.2.3",
      fields: [
        {
          label:
            "Мэргэжлийн багш нарын бүлэг, багийн үйл ажиллагаанд идэвхтэй оролцдог байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Хүүхдийн эрхийг хамгаалах, суралцагчдын хөгжил төлөвшлийг дэмжих, үе тэнгийн дээрэлхэлт, гадуурхал, хорт зуршил, гэмт хэргээс урьдчилан сэргийлэх, суралцагчдын хөгжил төлөвшлийг дэмжихэд багш, эцэг, эх, асран хамгаалагчтай хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын чанар, үр дүнг сайжруулахад бусад багш нартай  хамтран ажиллаж, арга зүй, туршлагаа сургууль бүсийн түвшинд хуваалцдаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Хүүхдийн авьяас, чадвар, хөгжих хэрэгцээг судалж, илрүүлэн, хөгжүүлэх үйл ажиллагааг санаачлан зохион байгуулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    JSON.parse(JSON.stringify(conclusionInfoTeacher)),
  ],
};

//bat

export const teacherJsonTerguulehBat = {
  name: "[Багш] Тэргүүлэx мэргэшлийн зэрэг (Бататгаx)",
  zeregType: 400,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),

    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [
            { text: "Тэргүүлэx", value: 2 },
            // { text: "Зөвлөx", value: 3 },
          ],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [
            // { text: "Шинэ", value: 1 },
            { text: "Бататгаx", value: 2 },
            // { text: "Аxиулаx", value: 3 },
            // { text: "Xүчингүй болгоx", value: 4 },
          ],
        },
        {
          label:
            "Заах аргач мэргэжлийн зэрэг өмнө нь авч байсан уу? /Тийм, Үгүй/",
          typeInput: "select",
          source: null,
          options: [
            { text: "Тийм", value: 1 },
            { text: "Үгүй", value: 2 },
          ],
        },

        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дугаар оруулаx",
          typeInput: "text",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний эxлэx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дуусаx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },

        {
          label:
            "ТИЙМ бол Мэргэжлийн зэргийн олгосон эрх бүхий албан тушаалтны албан ёсны шийдвэрийн хуулбар",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label:
            "Хугацаа дууссан бол хүчинтэй хугацаа хэвээр хадгалах дараах 5 нөхцөлөөс сонгоно",
          typeInput: "select",
          source: null,
          options: [
            { text: "Жирэмсний болон амаржсан (5.1.1)", value: 1 },
            { text: "Мэргэжил дээшлүүлэx (5.1.2)", value: 2 },
            { text: "Цэргийн алба (5.1.3)", value: 3 },
            { text: "Эрүүл мэндийн байдал (5.1.4)", value: 4 },
            { text: "Албан тушаал дэвшсэн, шилжсэн (5.1.5)", value: 5 },
          ],
          optional: true,
        },
        {
          label:
            "Xэвээр xадгалаx 8-р заалтанд сонгосон шалтгааны файл xавсаргаx",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label: "Зэргийн xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    //terguuleh shine
    JSON.parse(JSON.stringify(generalRequirement3)),
    {
      name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
      typeId: "section",
      indexx: "3.2.1",
      fields: [
        {
          label:
            "Боловсролын цахим, нээлттэй нөөц хэрэглэгдэхүүн, үнэлгээг бүтээлчээр хэрэглэдэг, орон нутгийн түвшинд арга зүй, туршлагаа хуваалцдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Хүүхдийн онцлог ялгаатай хэрэгцээнд суурилсан арга зүйг боловсруулан сургалт, үйл ажиллагааг зохион байгуулж, үр дүнд хүрсэн байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын нөөц хэрэглэгдэхүүнийг суралцагчдын ялгаатай хэрэгцээнд тохируулан хийж, хичээл сургалтын үйл ажиллагаанд үр дүнтэй ашигладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судлан, хэрэгжүүлж, орон нутгийн бусад сургалтын байгууллага, багш нарт зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
        {
          label:
            "Шинэлэг бүтээлч арга зүй технологийг турших,  хэрэгжүүлэх зорилгоор хичээлийн судалгааг зохион байгуулж, үр дүнг сургууль, орон нутгийн түвшинд хэлэлцүүлсэн байх",
          typeInput: "file",
          source: null,
          indexx: 5,
        },
      ],
    },
    {
      name: "Хамтын ажиллагаа",
      typeId: "section",
      indexx: "3.2.2",
      fields: [
        {
          label:
            "Багшийн хөгжлийг дэмжих үндэсний төв-ийн Арга зүйн эхний шатны сургалтад хамрагдаж амжилттай төгссөн эсэх. Төгссөн гэвэл төгссөн гэрчилгээг хавсаргана.",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },

        {
          label:
            "Багшийн хувийн хөгжлийн төлөвлөгөөг боловсруулан хэрэгжүүлж үр дүнг тооцсон байх",
          typeInput: "file",
          source: null,
          indexx: 2,
          optional: true,
        },

        {
          label:
            "Сургалтын чанар, үр дүн, суралцагчийн хөгжил, ахицад дүн шинжилгээ хийж, хугацаанд нь тайлагнадаг, хариу арга хэмжээг авдаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
          optional: true,
        },

        {
          label:
            "Мэргэжлийн багш нарын   бүлэг багийн үйл ажиллагаанд идэвхтэй оролцдог байх",
          typeInput: "file",
          source: null,
          indexx: 4,
          optional: true,
        },
      ],
    },
    {
      name: "Хамт олон, эцэг эх асран хамгаалагчийн сэтгэл ханамж",
      typeId: "section",
      indexx: "3.2.3.1",
      fields: [
        {
          label:
            "Ёс зүйтэй, шударга, адил тэгш харилцаж, ажил үүргээ гүйцэтгэхэд нь тусалж дэмждэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Бага, дунд, ахлах ангийн хүүхдийн хөгжлийг дэмжихэд чиглэсэн үр дүнг тооцсон байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Багшийн ёс зүй, харилцааны зөрчилгүй, бусадтай манлайлан ажилладаг, хамт олны үнэлгээгээр нотлогдсон",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Хүүхэд хамгааллын болон  дэмжлэгийн багийн гишүүд, эцэг эхтэй хамтран ажиллаж үр дүнд хүрсэн байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    JSON.parse(JSON.stringify(conclusionInfoTeacher)),
  ],
};

export const teacherJsonZaahNew = {
  name: "[Багш] Зааx аргач мэргэшлийн зэрэг (Шинэ)",
  forWhom: "teacher",
  zeregType: 100,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),

    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [
            { text: "Зааx аргач", value: 1 },
            // { text: "Тэргүүлэx", value: 2 },
            // { text: "Зөвлөx", value: 3 },
          ],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [
            { text: "Шинэ", value: 1 },
            // { text: "Бататгаx", value: 2 },
            // { text: "Аxиулаx", value: 3 },
            // { text: "Xүчингүй болгоx", value: 4 },
          ],
        },
        {
          label: "Xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    //ehniiih
    JSON.parse(JSON.stringify(generalRequirement5)),
    {
      name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
      typeId: "section",
      fields: [
        {
          label:
            "Сургалтын хөтөлбөрийн дагуу хичээлийг төлөвлөн үр дүнтэй зохион байгуулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
          indexxStr: "3.2.1",
        },

        {
          label:
            "Хичээл, сургалт зохион байгуулахдаа суралцагчийн ялгаатай суралцахуйг харгалзаж, дэмжлэг үзүүлдэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Явцын үнэлгээг тогмол хэрэгжүүлдэг,үр дүнд үндэслэн арга зүйгээ сайжруулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Боловсролын цахим, нээлттэй нөөцийг ашиглан сургалтын цахим хэрэглэгдэхүүн, үнэлгээг хичээл сургалтын үйл ажиллагаандаа хэрэгжүүлж, үр дүнг тооцсон байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Сургалтын нөөц хэрэглэгдэхүүнийг боловсруулж, хичээл сургалтын үйл ажиллагаанд үр дүнтэй ашигладаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Шинэлэг бүтээлч арга зүйг турших,  хэрэгжүүлэх зорилгоор судалгаат хичээл зохион байгуулж, хичээлийн судалгаанд хувь нэмэр оруулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
      ],
    },
    {
      name: "Xамтын ажиллагаа",
      typeId: "section",
      fields: [
        {
          label:
            "Багшийн хөгжлийг дэмжих үндэсний төв-ийн Арга зүйн эхний шатны сургалтад хамрагдаж амжилттай төгссөн үү? Төгссөн бол төгссөн гэрчилгээг хавсаргана уу!",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },
        {
          label:
            "Мэргэжлийн багш нарын бүлэг, багийн үйл ажиллагаанд идэвхтэй оролцдог байх",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },
        {
          label:
            "Хүүхдийн эрхийг хамгаалах, суралцагчдын хөгжил төлөвшлийг дэмжих, үе тэнгийн дээрэлхэлт, гадуурхал, хорт зуршил, гэмт хэргээс урьдчилан сэргийлэх, суралцагчдын хөгжил төлөвшлийг дэмжихэд багш, эцэг, эх, асран хамгаалагчтай хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },

        {
          label:
            "Сургалтын үйл ажиллагааг сайжруулахад бусад багш нартай идэвх санаачилгатай хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },

        {
          label:
            "Хүүхдийн хөгжил, төлөвшлийг дэмжих чиглэлээр хичээлээс гадуурх үйл ажиллагааг үр дүнтэй зохион байгуулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
          optional: true,
        },
      ],
    },
    JSON.parse(JSON.stringify(conclusionInfoTeacher)),
  ],
};

export const teacherJsonZaahBat = {
  name: "[Багш] Зааx аргач мэргэшлийн зэрэг (Бататгаx)",
  zeregType: 200,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),

    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [
            { text: "Зааx аргач", value: 1 },
            // { text: "Тэргүүлэx", value: 2 },
            // { text: "Зөвлөx", value: 3 },
          ],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [
            // { text: "Шинэ", value: 1 },
            { text: "Бататгаx", value: 2 },
            // { text: "Аxиулаx", value: 3 },
            // { text: "Xүчингүй болгоx", value: 4 },
          ],
        },
        {
          label:
            "Заах аргач мэргэжлийн зэрэг өмнө нь авч байсан уу? /Тийм, Үгүй/",
          typeInput: "select",
          source: null,
          options: [
            { text: "Тийм", value: 1 },
            { text: "Үгүй", value: 2 },
          ],
        },

        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дугаар оруулаx",
          typeInput: "text",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний эxлэx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дуусаx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },

        {
          label:
            "ТИЙМ бол Мэргэжлийн зэргийн олгосон эрх бүхий албан тушаалтны албан ёсны шийдвэрийн хуулбар",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label:
            "Хугацаа дууссан бол хүчинтэй хугацаа хэвээр хадгалах дараах 5 нөхцөлөөс сонгоно",
          typeInput: "select",
          source: null,
          options: [
            { text: "Жирэмсний болон амаржсан (5.1.1)", value: 1 },
            { text: "Мэргэжил дээшлүүлэx (5.1.2)", value: 2 },
            { text: "Цэргийн алба (5.1.3)", value: 3 },
            { text: "Эрүүл мэндийн байдал (5.1.4)", value: 4 },
            { text: "Албан тушаал дэвшсэн, шилжсэн (5.1.5)", value: 5 },
          ],
          optional: true,
        },
        {
          label:
            "Xэвээр xадгалаx 8-р заалтанд сонгосон шалтгааны файл xавсаргаx",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label: "Зэргийн xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    //Бататгаx
    {
      name: "Ерөнxий шалгуур",
      typeId: "section",
      fields: [
        {
          label:
            "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
          typeInput: "file",
          source: null,
          indexx: 5,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
          typeInput: "file",
          source: null,
          indexx: 7,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
          typeInput: "number",
          source: null,
          min: 75,
        },
      ],
    },
    //Бататгаx
    {
      name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
      indexxString: "3.2.1",
      typeId: "section",
      fields: [
        {
          label:
            "Боловсролын цахим, нээлттэй нөөцийг ашиглан сургалтын цахим хэрэглэгдэхүүн, үнэлгээг хичээл сургалтын үйл ажиллагаандаа хэрэгжүүлж, үр дүнг тооцсон байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Хүүхдийн онцлог ялгаатай хэрэгцээнд суурилсан арга зүйг боловсруулан сургалт, үйл ажиллагааг зохион байгуулж, үр дүнд хүрсэн байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Сургалтын нөөц хэрэглэгдэхүүнийг боловсруулж, хичээл сургалтын үйл ажиллагаанд үр дүнтэй ашигладаг байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судалж, сургуулийн хэмжээнд багш нартай хуваалцдаг, зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Шинэлэг бүтээлч арга зүйг турших,  хэрэгжүүлэх зорилгоор судалгаат хичээл зохион байгуулж, хичээлийн судалгаанд хувь нэмэр оруулдаг байх",
          typeInput: "file",
          source: null,
        },
      ],
    },
    ///////
    JSON.parse(JSON.stringify(conclusionInfoTeacher)),
    /////
  ],
};
